import { type } from "../../types/types";

export default function reducer(
  state = { variants: [], variantDetail: {} },
  action
) {
  switch (action.type) {
    case type.SET_VARIANTS:
      return { ...state, ...action.variants };
    case type.SET_VARIANT_DETAIL:
      return { ...state, ...action.variantDetail };
    default:
      return { ...state };
  }
}
